import { render, staticRenderFns } from "./DocumentSection.vue?vue&type=template&id=f17188ee&scoped=true&"
import script from "./DocumentSection.vue?vue&type=script&lang=ts&"
export * from "./DocumentSection.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentSection.vue?vue&type=style&index=0&id=f17188ee&scoped=true&lang=css&"
import style1 from "./DocumentSection.vue?vue&type=style&index=1&id=f17188ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17188ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VBtn,VCard,VCardText,VSpacer})
